import React from 'react';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const { addToWishlist, removeFromWishlist, isInWishlist } = useWishlist();

  const {
    id,
    name,
    price,
    originalPrice,
    discount,
    rating,
    reviewCount,
    image,
    badge
  } = product;

  const handleAddToCart = () => {
    addToCart(product);
  };

  const handleWishlistToggle = () => {
    if (isInWishlist(id)) {
      removeFromWishlist(id);
    } else {
      addToWishlist(product);
    }
  };

  return (
    <div className="group relative overflow-hidden rounded-2xl bg-white border border-black/5
      shadow-[0_2px_10px_rgba(27,27,31,0.06)] hover:shadow-[0_14px_28px_rgba(27,27,31,0.14)]
      transition-shadow duration-300">
      {/* Badge */}
      {badge && (
        <div className="absolute top-2.5 right-2.5 z-10">
          <span className="bg-[#1B1B1F] text-white text-[11px] font-bold px-2.5 py-1 rounded-full">
            {badge}
          </span>
        </div>
      )}

      {/* Wishlist Button */}
      <button
        aria-label="أضف إلى المفضلة"
        className="inline-flex items-center justify-center rounded-full w-9 h-9
          absolute top-2.5 left-2.5 z-10 bg-white/90 shadow-sm
          opacity-0 group-hover:opacity-100 transition-opacity
          hover:bg-[#F2B705] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705]"
        onClick={handleWishlistToggle}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`w-4 h-4 ${isInWishlist(id) ? 'fill-[#FF4D4D] text-[#FF4D4D]' : 'text-[#1B1B1F]'}`}
        >
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
        </svg>
      </button>

      {/* Product Image */}
      <div className="aspect-square overflow-hidden bg-[#F6F5F2]">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Product Info */}
      <div className="p-4">
        <h3 className="text-sm font-medium text-[#1B1B1F] mb-2 line-clamp-2 h-10">
          {name}
        </h3>

        {/* Rating */}
        <div className="flex items-center gap-1 mb-2">
          <div className="flex">
            {[...Array(5)].map((_, i) => (
              <svg
                key={i}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`w-3 h-3 ${
                  i < Math.floor(rating)
                    ? 'text-[#F2B705] fill-current'
                    : 'text-gray-300'
                }`}
              >
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
            ))}
          </div>
          <span className="text-xs text-gray-500">({reviewCount})</span>
        </div>

        {/* Price */}
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <span className="text-lg font-bold text-[#1B1B1F]">
            {price} ر.س
          </span>
          {originalPrice && (
            <span className="text-sm text-gray-400 line-through">
              {originalPrice} ر.س
            </span>
          )}
          {discount && (
            <span className="text-[11px] font-bold bg-[#FF4D4D]/10 text-[#FF4D4D] px-2 py-0.5 rounded-full">
              -{discount}%
            </span>
          )}
        </div>

        {/* Add to Cart Button */}
        <button
          className="inline-flex items-center justify-center whitespace-nowrap rounded-full
            text-sm font-bold transition-colors duration-200
            bg-[#F2B705] hover:bg-[#1B1B1F] text-[#1B1B1F] hover:text-white px-4 py-2.5 w-full
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2"
          onClick={handleAddToCart}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="w-4 h-4 ml-2"
          >
            <circle cx="8" cy="21" r="1" />
            <circle cx="19" cy="21" r="1" />
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />
          </svg>
          أضف إلى السلة
        </button>
      </div>
    </div>
  );
}

export default ProductCard;
